import type { SVGProps } from 'react';

export const InputMultiselect = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'input multiselect'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <circle cx="16" cy="16" fill="#F2F4F9" r="16" />
      <g transform="translate(7, 6)">
        <g>
          <polygon points="0 0 3.69230769 0 3.69230769 3.64891955 0 3.64891955" />
          <path
            d="M3.23076923,-9.12252694e-05 L0.461538462,-9.12252694e-05 C0.206538462,-9.12252694e-05 0,0.204025315 0,0.456035122 L0,3.1927932 C0,3.44480301 0.206538462,3.64891955 0.461538462,3.64891955 L3.23076923,3.64891955 C3.48576923,3.64891955 3.69230769,3.44480301 3.69230769,3.1927932 L3.69230769,0.456035122 C3.69230769,0.204025315 3.48576923,-9.12252694e-05 3.23076923,-9.12252694e-05"
            fill="#898C9A"
          />
        </g>
        <path
          d="M3.23076923,5.20127715 L0.461538462,5.20127715 C0.206538462,5.20127715 0,5.40539369 0,5.6574035 L0,8.39416158 C0,8.64617139 0.206538462,8.85028793 0.461538462,8.85028793 L3.23076923,8.85028793 C3.48576923,8.85028793 3.69230769,8.64617139 3.69230769,8.39416158 L3.69230769,5.6574035 C3.69230769,5.40539369 3.48576923,5.20127715 3.23076923,5.20127715"
          fill="#898C9A"
        />
        <g transform="translate(5.5385, 1.2542)">
          <polygon points="0 0 12.9230308 0 12.9230308 1.14031587 0 1.14031587" />
          <path
            d="M12.6923077,1.14031587 L0.230769231,1.14031587 C0.103384615,1.14031587 0,1.03814357 0,0.912252694 L0,0.228063173 C0,0.102172302 0.103384615,0 0.230769231,0 L12.6923077,0 C12.8196923,0 12.9230769,0.102172302 12.9230769,0.228063173 L12.9230769,0.912252694 C12.9230769,1.03814357 12.8196923,1.14031587 12.6923077,1.14031587"
            fill="#898C9A"
          />
        </g>
        <g transform="translate(5.5385, 6.4556)">
          <polygon points="0 0 12.9230308 0 12.9230308 1.14031587 0 1.14031587" />
          <path
            d="M12.6923077,1.14031587 L0.230769231,1.14031587 C0.103384615,1.14031587 0,1.03814357 0,0.912252694 L0,0.228063173 C0,0.102172302 0.103384615,0 0.230769231,0 L12.6923077,0 C12.8196923,0 12.9230769,0.102172302 12.9230769,0.228063173 L12.9230769,0.912252694 C12.9230769,1.03814357 12.8196923,1.14031587 12.6923077,1.14031587"
            fill="#898C9A"
          />
        </g>
        <path
          d="M3.23076923,10.6617709 L0.461538462,10.6617709 C0.206538462,10.6617709 0,10.8658875 0,11.1178973 L0,13.8546553 C0,14.1066651 0.206538462,14.3107817 0.461538462,14.3107817 L3.23076923,14.3107817 C3.48576923,14.3107817 3.69230769,14.1066651 3.69230769,13.8546553 L3.69230769,11.1178973 C3.69230769,10.8658875 3.48576923,10.6617709 3.23076923,10.6617709 L3.23076923,10.6617709 Z M0.576923077,13.7406238 L3.11538462,13.7406238 L3.11538462,11.2319288 L0.576923077,11.2319288 L0.576923077,13.7406238 Z"
          fill="#898C9A"
        />
        <g transform="translate(5.5385, 11.9162)">
          <polygon points="0 0 12.9230308 0 12.9230308 1.14031587 0 1.14031587" />
          <path
            d="M12.6923077,1.14031587 L0.230769231,1.14031587 C0.103384615,1.14031587 0,1.03814357 0,0.912252694 L0,0.228063173 C0,0.102172302 0.103384615,0 0.230769231,0 L12.6923077,0 C12.8196923,0 12.9230769,0.102172302 12.9230769,0.228063173 L12.9230769,0.912252694 C12.9230769,1.03814357 12.8196923,1.14031587 12.6923077,1.14031587"
            fill="#898C9A"
          />
        </g>
        <g transform="translate(5.5385, 11.9162)">
          <polygon points="0 0 12.9230308 0 12.9230308 1.14031587 0 1.14031587" />
          <path
            d="M12.6923077,1.14031587 L0.230769231,1.14031587 C0.103384615,1.14031587 0,1.03814357 0,0.912252694 L0,0.228063173 C0,0.102172302 0.103384615,0 0.230769231,0 L12.6923077,0 C12.8196923,0 12.9230769,0.102172302 12.9230769,0.228063173 L12.9230769,0.912252694 C12.9230769,1.03814357 12.8196923,1.14031587 12.6923077,1.14031587"
            fill="#898C9A"
          />
        </g>
        <path
          d="M3.23076923,16.3509892 L0.461538462,16.3509892 C0.206538462,16.3509892 0,16.5551058 0,16.8071156 L0,19.5438737 C0,19.7958835 0.206538462,20 0.461538462,20 L3.23076923,20 C3.48576923,20 3.69230769,19.7958835 3.69230769,19.5438737 L3.69230769,16.8071156 C3.69230769,16.5551058 3.48576923,16.3509892 3.23076923,16.3509892"
          fill="#898C9A"
        />
        <g transform="translate(5.5385, 17.6053)">
          <polygon points="0 0 12.9230308 0 12.9230308 1.14031587 0 1.14031587" />
          <path
            d="M12.6923077,1.14031587 L0.230769231,1.14031587 C0.103384615,1.14031587 0,1.03814357 0,0.912252694 L0,0.228063173 C0,0.102172302 0.103384615,0 0.230769231,0 L12.6923077,0 C12.8196923,0 12.9230769,0.102172302 12.9230769,0.228063173 L12.9230769,0.912252694 C12.9230769,1.03814357 12.8196923,1.14031587 12.6923077,1.14031587"
            fill="#898C9A"
          />
        </g>
      </g>
    </g>
  </svg>
);
